import { JobEntity, JobOperation, JobStatus } from '@commenda/api';
import { SWRConfiguration } from 'swr';

interface JobWatcherOptions extends SWRConfiguration {
  refreshInterval?: number;
  revalidateOnFocus?: boolean;
  revalidateOnReconnect?: boolean;
}

export const JOB_FETCHER_DEFAULT_OPTIONS: JobWatcherOptions = {
  refreshInterval: 10000,
  revalidateOnFocus: false,
  revalidateOnReconnect: true,
};

export const JOB_LIST_DEFAULT_SIZE = 100;

export const JOB_ENTITY_TO_TEXT: Record<JobEntity, string> = {
  [JobEntity.PRODUCT]: 'Product',
  [JobEntity.INVOICE]: 'Transaction',
  [JobEntity.FILING]: 'Filing',
  [JobEntity.CUSTOMER]: 'Customer',
  [JobEntity.CORPORATION]: 'Corporation',
  [JobEntity.EXPOSURE_SYNC]: 'Exposure sync',
};

export const JOB_OPERATION_TO_TEXT: Record<JobOperation, string> = {
  [JobOperation.IMPORT]: 'Import',
  [JobOperation.DELETE]: 'Delete',
  [JobOperation.EXPORT]: 'Export',
  [JobOperation.EXPORT_FILING_REPORT_FOR_CORPORATION]: 'Export',
  [JobOperation.EXPORT_JURISDICTION_TAX_REPORT]: 'Export',
};

export const JOB_STATUS_CONFIG: Record<
  JobStatus,
  { label: string; variant: string }
> = {
  [JobStatus.PENDING]: { label: 'Pending', variant: 'gray' },
  [JobStatus.PROCESSING]: { label: 'Processing', variant: 'blue' },
  [JobStatus.QUEUED]: { label: 'Queued', variant: 'gray' },
  [JobStatus.COMPLETED]: { label: 'Completed', variant: 'success' },
  [JobStatus.FAILED]: { label: 'Failed', variant: 'error' },
};
